export class DatePicker {
    showLabel?:boolean;
    autocomplete?:string;
    noAutoCompleteNull?:boolean;
    focusInitial?:boolean;
    validatorMessage?: boolean;
    tooltipMessage?: boolean;
    submitted?: boolean;
    validatorAlert?: boolean;
}